import firebase from 'firebase';
const firebaseConfig = {
  apiKey: "AIzaSyAdgW74zKcNhYCW_hlkVq1kUqVg8sYDy5g",
  authDomain: "starparty-de68d.firebaseapp.com",
  databaseURL: "https://starparty-de68d.firebaseio.com",
  projectId: "starparty-de68d",
  storageBucket: "starparty-de68d.appspot.com",
  messagingSenderId: "583897264347",
  appId: "1:583897264347:web:e1802af4a183767a6a5cfe",
  measurementId: "G-SP3118PCW0"
};
const fire = firebase.initializeApp(firebaseConfig);
export default fire;